import styled from "styled-components";
import {StyledDialog} from "../layout/styles";

export const StyledErrorDialog = styled(StyledDialog)`
  && .MuiDialog-paperWidthXs {
    width: 400px;
    height: 230px;
  }
`;
